module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAARVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////9SnXPCAAAAF3RSTlMAJIPH3/+/exgEi/v3c7ejjyjX45ObMD2JtHAAAACySURBVHgB7dTVAcNQAEJR4u6y/6j9rSvUwh2AE31wzh0WhFGcvFicZjnOV5RVQqluzu+3Ca0OZ+oTYg1OGiomUOfkGzgpOwFGLpCeADUXiE+AhNw/AAYM4MH+AjBggND2AJ9FBgz4LPJZ9JeAAQPkYMCAgUkNRGogFANVIAZKaIG00AJzASEQLytwG+jBTr0P9T7U+1DvQ70P9T7U+1DvQ70P9T7U+1DvQ70P9T50+865HXFCU5/aAggeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat-white-icon.png
// module id = 380
// module chunks = 0